module.exports = __webpack_public_path__ + "static/media/ico-fpay.22e94e40.svg";